'use client';

import { Construction } from 'lucide-react';
import HeroVista from '@/components/HeroVista';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

// Pantalla genérica "en construcción" para los módulos aún no implementados.
export default function Placeholder({ vista }: { vista: string }) {
  return (
    <div className="space-y-6">
      <HeroVista
        icono={Construction}
        titulo="Sección en construcción"
        descripcion="Este módulo se construirá en un próximo incremento."
      />

      <Card>
        <CardHeader className="items-center text-center">
          <span className="mb-2 flex size-16 items-center justify-center rounded-full bg-accent text-accent-foreground">
            <Construction className="size-8" />
          </span>
          <CardTitle className="text-lg">
            Esta sección («{vista}») se construirá en un próximo incremento.
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-sm text-muted-foreground">
            El diseño y los flujos ya están documentados en <code>docs/</code>.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
